import React from 'react';

import { InputLabel } from '@material-ui/core';
import ObjectiveNameAutoComplete from 'components/ObjectiveTagList/ObjectiveNameAutoComplete';
import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography12 } from 'uiToolkit/Typography';

import { useObjectiveSidepanel } from '../context/ObjectiveSidePanelContext';

const ObjectiveName = () => {
  const { state, setName } = useObjectiveSidepanel();
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <InputLabel htmlFor="objective-name-field">
        <Typography12>Name*</Typography12>
        <TextFieldContainer>
          <ObjectiveNameAutoComplete
            onInputChange={(name, objectiveData) => {
              setName(name, objectiveData);
            }}
            selectedTimeBoundPeriod={state.timeBoundDetails}
            placeholder="e.g. Improve NPS, Delight users etc......."
          />
        </TextFieldContainer>
      </InputLabel>
    </div>
  );
};

const TextFieldContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  height: 66px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0px;
  background-color: ${theme.palette.background.paper};
  border: 1px solid ${theme.palette.borders.lighterGrey};
  border-radius: 5px;
    input {
      padding-left 12px;
      font-size: 1rem;
    }
`;

export default ObjectiveName;
